var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { getLobExpansionKey } from '../constants';
import { useSelectCurrency, useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
import { AnnualSectionTable } from './annualSectionTable';
import { ExpandableTotalSection } from './expandableTotalSection';
import { MultigeoLobRow } from './multigeoQueuesByLob';
import { MultiskillGroupRows } from './multiskillGroupRow';
import { getQueueExpansionKeysForLob, useMultiskillGroupExpansionKeys, useMultiskillGroupNames, useQueueExpansionKeys, useSelectQueuesByLobPerScenario } from './selectors';
var AnnualMetricSection = function (_a) {
  var metricKey = _a.metricKey,
    totalLabelKey = _a.totalLabelKey,
    expandedItems = _a.expandedItems,
    onToggleItem = _a.onToggleItem;
  var t = useTranslation('report', {
    keyPrefix: 'annual'
  }).t;
  var translate = t;
  var data = useSummaryByDisplayMode();
  var chunkSize = useSummaryChunkSize();
  var lobsPerScenario = useSelectQueuesByLobPerScenario();
  var multiskillGroupNames = useMultiskillGroupNames(data !== null && data !== void 0 ? data : []);
  if (!data || !lobsPerScenario.length) return null;
  return _jsxs(ExpandableTotalSection, __assign({
    label: translate(totalLabelKey),
    valueKey: metricKey,
    expansionKey: metricKey,
    expandedItems: expandedItems,
    onToggleItem: onToggleItem
  }, {
    children: [lobsPerScenario.map(function (lobEntry) {
      return _jsx(MultigeoLobRow, {
        lob: lobEntry.template,
        perScenarioLob: lobEntry.perScenarioLob,
        data: data,
        chunkSize: chunkSize,
        keyItem: metricKey,
        hideConstraintHeader: true,
        expandedItems: expandedItems,
        onToggleItem: onToggleItem
      }, "".concat(metricKey, "-").concat(lobEntry.lobName));
    }), _jsx(MultiskillGroupRows, {
      groupNames: multiskillGroupNames,
      data: data,
      chunkSize: chunkSize,
      valueKey: metricKey,
      showVariance: true,
      expandedItems: expandedItems,
      onToggleItem: onToggleItem
    })]
  }));
};
export var createAnnualMetricTable = function (_a) {
  var metricKey = _a.metricKey,
    titleKey = _a.titleKey,
    totalLabelKey = _a.totalLabelKey,
    unitKey = _a.unitKey;
  var TableBodyComponent = function (props) {
    return _jsx(AnnualMetricSection, __assign({}, props, {
      metricKey: metricKey,
      totalLabelKey: totalLabelKey
    }));
  };
  function ConfiguredAnnualMetricTable() {
    var t = useTranslation('report', {
      keyPrefix: 'annual'
    }).t;
    var translate = t;
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var lobExpansionItems = lobsPerScenario.map(function (_a) {
      var lobName = _a.lobName;
      return getLobExpansionKey(lobName);
    });
    var queues = useQueueExpansionKeys(lobsPerScenario);
    var data = useSummaryByDisplayMode();
    var multiskillExpansionItems = useMultiskillGroupExpansionKeys(data !== null && data !== void 0 ? data : []);
    var currency = useSelectCurrency();
    var expansionItems = __spreadArray(__spreadArray(__spreadArray([metricKey], lobExpansionItems, true), queues, true), multiskillExpansionItems, true);
    var getNestedExpansionItems = function (itemName) {
      if (itemName === metricKey) return __spreadArray(__spreadArray(__spreadArray([], lobExpansionItems, true), queues, true), multiskillExpansionItems, true);
      var lobEntry = lobsPerScenario.find(function (_a) {
        var lobName = _a.lobName;
        return getLobExpansionKey(lobName) === itemName;
      });
      if (!lobEntry) return [];
      return getQueueExpansionKeysForLob(lobEntry);
    };
    return _jsx(AnnualSectionTable, {
      title: translate(titleKey, {
        currency: currency
      }),
      unit: translate(unitKey),
      expansionItems: expansionItems,
      getNestedExpansionItems: getNestedExpansionItems,
      tableBodyComponent: TableBodyComponent
    });
  }
  return ConfiguredAnnualMetricTable;
};